<style lang="scss" scoped>
img {
  min-width: 100%;
}
#slide {
  position: absolute;
  bottom: -100%;
  width: 100%;
  transition: 1s;
  opacity: 0.8;

  box-sizing: border-box;
}

.avatar {
  display: block;
  position: relative;
  overflow: hidden;
  background-size: cover;

  &::before {
    content: "";
    display: block;
    padding-top: 100%;
    width: 100%;
  }
  &:hover #slide {
    transition: 1s;
    bottom: 10%;
  }
}
</style>

<template>
  <div class="row rounded profile-shortInfo">
    <div class="col-12 border ">
      <div class="row">
        <div class="col-12 bg-white profile-shortInfo-picture p-0">
          <a
            :href="profileUrl"
            class="avatar"
            :style="{ 'background-image': 'url(' + primaryImageUrl + ')' }"
          >
            <div id="slide" class="row bg-white m-0">
              <div class="col-12 text-primary">
                <a class="profile-name" :href="profileUrl">{{
                  profile.name
                }}</a>
                <i
                  class="fas fa-circle"
                  :class="{
                    'text-success': isOnline,
                    'text-danger': !isOnline
                  }"
                ></i>
              </div>
              <div class="col-12 text-primary">
                <label class="text-lg">{{ profile.sex }},</label>
                <label class="text-lg">{{ profile.age }} Jahre</label>
              </div>
              <div class="col-12 text-primary">
                <label class="profile-country"
                  >{{ profile.country }}, {{ profile.anonymous_zipcode }}</label
                >
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="babel">
export default {
    data () {
      return {
        profileUrl: "/profile/"+this.profile.name,
      };
    },
    props:{
      profile: {
        required: true,
        type: Object
      }
    },
    computed: {
      isOnline() {
        return this.$store.getters["online/profileOnline"](this.profile.id);
      },
      primaryImageUrl() {
        return this.profile.primary_image.url + '?width=' + Laravel.settings.imagesize.proposalImages + '&height=' + Laravel.settings.imagesize.proposalImages;
      }
    }
  };
</script>
